module.exports = __webpack_public_path__ + "static/media/ExitAttendee.c4f02138.wav";